import type React from 'react';

import { SkeletonButton } from '@xing-com/skeleton';
import { Column, Row } from '@xing-com/xing-grid';

import { Styled } from './styles';

const RecommendationCardSkeleton: React.FC = () => {
  return (
    <Styled.RecommendationsCardSkeletonContainer>
      <Styled.RecommendationsCardSkeletonProfileImage size="xxlarge" />

      <Styled.RecommendationsCardSkeletonBodyCopy amountRows={1} />
      <Styled.RecommendationsCardSkeletonBodyCopy amountRows={2} />
      <Styled.RecommendationsCardSkeletonBodyCopy amountRows={2} />

      <SkeletonButton />
    </Styled.RecommendationsCardSkeletonContainer>
  );
};

const RecommendationsSkeleton: React.FC = () => {
  const fakeRecos = Array(8).fill(0);

  return (
    <Styled.RecommendationsSkeletonContainer>
      <Row>
        {fakeRecos.map((_, index) => {
          return (
            <Column key={index} size={6} sizeConfined={4} sizeDesktop={3}>
              <RecommendationCardSkeleton />
            </Column>
          );
        })}
      </Row>
    </Styled.RecommendationsSkeletonContainer>
  );
};

export default RecommendationsSkeleton;
